// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("./Common.res.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Caml_option = require("rescript/lib/js/caml_option.js");

var isString = (obj => typeof obj === 'string');

var isBool = (obj => typeof obj === 'boolean');

var isArray = (obj => Array.isArray(obj));

var isObject = (obj => obj !== undefined && obj !== null && !Array.isArray(obj) && typeof obj === 'object');

var isFunction = (obj => typeof obj === 'function');

function reqExn(nullable, msg) {
  if (nullable == null) {
    return Js_exn.raiseError("A required attribute is missing: " + msg);
  } else {
    return nullable;
  }
}

function reqStrExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isString(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not a string: " + msg);
  }
}

function optStrExn(nullable, msg) {
  if (!(nullable == null)) {
    if (isString(nullable)) {
      return nullable;
    } else {
      return Js_exn.raiseError("Not a string: " + msg);
    }
  }
  
}

function reqBoolExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isBool(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not a boolean: " + msg);
  }
}

function optBoolExn(nullable, msg) {
  if (!(nullable == null)) {
    if (isBool(nullable)) {
      return nullable;
    } else {
      return Js_exn.raiseError("Not a boolean: " + msg);
    }
  }
  
}

function reqArrExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isArray(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not an array: " + msg);
  }
}

function reqObjExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isObject(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not an object: " + msg);
  }
}

function optObjExn(nullable, msg) {
  if (!(nullable == null)) {
    if (isObject(nullable)) {
      return Caml_option.some(nullable);
    } else {
      return Js_exn.raiseError("Not an object: " + msg);
    }
  }
  
}

function reqFuncExn(nullable, msg) {
  var res = reqExn(nullable, msg);
  if (isFunction(res)) {
    return res;
  } else {
    return Js_exn.raiseError("Not a function: " + msg);
  }
}

function invokeExnFunc(title, func) {
  var res = Common.catchExn(func);
  if (res.TAG === "Ok") {
    return {
            TAG: "Ok",
            _0: res._0
          };
  }
  var match = res._0;
  var stack = match.stack;
  return {
          TAG: "Error",
          _0: title + ": " + match.msg + "." + (
            stack !== "" ? "\n" + stack : ""
          )
        };
}

var executeFunctionBody = (body => new Function("", body)());

var executeAsyncFunctionBody = (body => {
    const AsyncFunction = Object.getPrototypeOf(async function(){}).constructor;
    return (new AsyncFunction(body))();
});

var makeFunction = ((args,body) => new Function(args, body));

exports.isString = isString;
exports.isBool = isBool;
exports.isArray = isArray;
exports.isObject = isObject;
exports.isFunction = isFunction;
exports.reqStrExn = reqStrExn;
exports.optStrExn = optStrExn;
exports.reqBoolExn = reqBoolExn;
exports.optBoolExn = optBoolExn;
exports.reqArrExn = reqArrExn;
exports.reqObjExn = reqObjExn;
exports.optObjExn = optObjExn;
exports.reqFuncExn = reqFuncExn;
exports.invokeExnFunc = invokeExnFunc;
exports.executeFunctionBody = executeFunctionBody;
exports.executeAsyncFunctionBody = executeAsyncFunctionBody;
exports.makeFunction = makeFunction;
/* Common Not a pure module */
